import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Button, Alert } from 'react-bootstrap';
import api from '../utils/api';
import '../App.css';
import useAuth from '../context/useAuth';

class MemberDetails extends Component {
    constructor(props) {
        super(props);
        console.log(props);
        // Assuming role is passed as a prop from a wrapper component
        const { searchCriteria, currentPage } = props.location.state || {};
        const queryParams = new URLSearchParams(window.location.search);
        const page = queryParams.get('page');

        this.state = {
            member: {},
            error: null,
            searchCriteria,
            currentPage,
            role: props.role,
            receiptpage: page
        };
    }

    componentDidMount() {
        this.getMember();
    }

    formatDate = (dateStr) => {
        // Check if dateStr is undefined, null, or an empty string
        if (!dateStr) {
            return ''; // Return an empty string or any default value if dateStr is not valid
        }

        // Split the date string into its components
        const [year, month, day] = dateStr.split('-');

        // Return the formatted date as MM/DD/YYYY
        return `${month}/${day}/${year}`;
    };

    handleBack = () => {
        const { searchCriteria, currentPage } = this.state;

        // Check if location state has a 'fromCardPayments' flag
        if (this.props.location.state && this.props.location.state.fromCardPayments) {
            // Go back to card payments page with the previous page preserved
            this.props.history.push({
                pathname: '/cardpayments',
                search: this.props.location.state.page ? `?page=${this.props.location.state.page}` : '',
                state: {
                    searchCriteria: this.props.location.state.searchCriteria || {}
                }
            });
        } else {
            // Default logic: go back to members page
            this.props.history.push({
                pathname: '/members',
                state: { searchCriteria, currentPage }
            });
        }
    };
    getMember() {
        const { memberId } = this.props.match.params;
        api.get(`/api/members/${memberId}`)
            .then(res => {
                this.setState({ member: res.data.data });
            })
            .catch(error => {
                if (error.response && (error.response.status === 401 || error.response.status === 403)) {
                    console.log('User is not authenticated or token expired. Redirecting to login page.');
                    this.props.history.push('/login');
                }
                else {
                    if (error.response && error.response.status === 404) {
                        this.setState({ error: 'No member account found. Please enter a valid member account number.' });
                    } else {
                        this.setState({ error: 'Failed to fetch member. Please try again later.' });
                    }
                }
            });
    }

    handleEdit = () => {
        const { member } = this.state;
        const { searchCriteria, currentPage } = this.state;
        //console.log('Calling editMember for ', member.memberId);
        this.props.history.push({
            pathname: `/editMember/${member.memberId}`,
            state: { member, searchCriteria, currentPage }
        });
    };

    handleDonation = () => {
        const { member } = this.state;
        const { searchCriteria, currentPage } = this.state;
        //console.log('Calling add Donation for ', member.memberId);
        this.props.history.push({
            pathname: `/addNewReceipt/${member.memberId}`,
            state: { member, searchCriteria, currentPage }
        });
    };

    handleMemo = () => {
        const { member } = this.state;
        const { searchCriteria, currentPage } = this.state;
        //console.log('Calling memo for ', member.memberId);
        this.props.history.push({
            pathname: `/memo-management/${member.memberId}`,
            state: { member, searchCriteria, currentPage }
        });
    };
    /**
        handleDelete = () => {
            const { memberId } = this.state.member;
            const path = `/api/members/${memberId}`;
            api.delete(path)
                .then(res => {
                    if (res.data.error) {
                        this.setState({ error: res.data.error });
                    } else {
                        setTimeout(() => {
                            if (this.state.receiptpage) {
                                this.props.history.push(`/receipts?page=${this.state.receiptpage}`);
                            } else {
                                const { searchCriteria, currentPage } = this.state;
                                this.props.history.push({
                                    pathname: '/members',
                                    state: { searchCriteria, currentPage }
                                });
                            }
                        }, 3000); // Redirect after 3 seconds
                    }
                })
                .catch(error => {
                    this.setState({ error: error.message });
                });
        }; */

    render() {
        const { member, error, role } = this.state;

        return (
            <div>
                {error && <Alert variant="danger">{error}</Alert>}
                {!error && (
                    <div className="ItemDetail">
                        <span>
                            <span>Member Details</span>
                            <Button className="btn btn-secondary" style={{ float: "right" }} onClick={this.handleBack}>Go Back</Button>
                        </span>
                        <div className="row">
                            <div className="col">
                                <div className="m-3">
                                    <div>Name</div>
                                    <div className="memberinfo">{member.first1} {member.middle1} {member.last1}</div>
                                </div>
                                <div className="m-3">
                                    <div>Spouse</div>
                                    <div className="memberinfo">
                                        {member.first2} {member.middle2} {member.last2}
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Address or Business Name</div>
                                    <div className="memberinfo">
                                        <div>{member.address}</div>
                                        <div>{member.address2}</div>
                                        <div>{member.city}, {member.state} {member.zip}</div>
                                        <div>{member.country}</div>
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Phones</div>
                                    <div className="memberinfo">
                                        <div>{member.phone1}</div>
                                        <div>{member.phone2}</div>
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Email</div>
                                    <div className="memberinfo">
                                        <div>{member.email}</div>
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>
                                        <input
                                            type="checkbox"
                                            id="confidentialName"
                                            checked={member.isNameConfidential}

                                        />
                                        <label htmlFor="confidentialName" className="ml-2">
                                            Keep name confidential
                                        </label>
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Member Type</div>
                                    <div className="memberinfo">
                                        <div>{member.memberType ? member.memberType : "DEVOTEE"}</div>
                                    </div>
                                </div>
                            </div>
                            <div className="col">
                                <div className="m-3">
                                    <div>Member Account #</div>
                                    <div className="memberinfo">
                                        {member.memberId}
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Last Donation</div>
                                    <div className="memberinfo">
                                        {member.lastDonation}
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Last Donation Date</div>
                                    <div className="memberinfo">
                                        {this.formatDate(member.lastDonationDate)}
                                    </div>
                                </div>
                                <div className="m-3">
                                    <div>Lifetime Donation</div>
                                    <div className="memberinfo">
                                        {member.totalDonation}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {!error && (role === 'ops' || role === 'admin') && (
                    <span>
                        <Button className="btn btn-secondary m-1 no-print" onClick={this.handleEdit}>Edit</Button>
                        <Button className="btn btn-secondary m-1 no-print" onClick={this.handleDonation}>Add Donation</Button>
                        <Button className="btn btn-secondary m-1 no-print" onClick={this.handleMemo}>Add Memo</Button>
                    </span>

                )}
                {!error && (role === 'member') && (
                    <span>
                        <Button className="btn btn-secondary m-1 no-print" onClick={this.handleEdit}>Edit</Button>
                    </span>
                )}
            </div>
        );
    }
}

// Wrapper component to use Auth hook
const MemberDetailsWithAuth = props => {
    const { role } = useAuth();
    return <MemberDetails {...props} role={role} />;
};

export default withRouter(MemberDetailsWithAuth);